import { X } from 'lucide-react';

/**
 * @param {{
 *   title: string;
 *   ariaLabel?: string;
 *   onClose: () => void;
 *   onApply?: () => void;
 *   applyLabel?: string;
 *   cancelLabel?: string;
 *   error?: string;
 *   footerVariant?: 'footer-actions' | 'header-actions' | 'none';
 *   className?: string;
 *   children: import('react').ReactNode;
 * }} props
 */
function FloorPlanEditModal({
  title,
  ariaLabel,
  onClose,
  onApply,
  applyLabel = 'Apply',
  cancelLabel = 'Cancel',
  error = '',
  footerVariant = 'footer-actions',
  className = '',
  children,
}) {
  const showHeaderActions = footerVariant === 'header-actions' && onApply;

  return (
    <div className="new-design-theme-popup-backdrop" role="presentation" onClick={onClose}>
      <div
        className={`new-design-theme-popup floor-plan-edit-modal floor-plan-material-picker-popup${
          className ? ` ${className}` : ''
        }`}
        role="dialog"
        aria-label={ariaLabel ?? title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="new-design-theme-popup-head">
          <h2 className="new-design-theme-popup-title">{title}</h2>
          {showHeaderActions ? (
            <div className="new-design-theme-popup-actions">
              <button
                type="button"
                className="btn btn-ghost new-design-theme-popup-close floor-plan-edit-modal-close"
                onClick={onClose}
                aria-label="Close"
              >
                <X size={18} strokeWidth={2.25} aria-hidden />
              </button>
              <button type="button" className="btn btn-primary btn-sm" onClick={onApply}>
                {applyLabel}
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="btn btn-ghost new-design-theme-popup-close floor-plan-edit-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              <X size={18} strokeWidth={2.25} aria-hidden />
            </button>
          )}
        </div>

        <div className="floor-plan-edit-modal-body">{children}</div>

        {error ? <p className="floor-plan-wall-length-error">{error}</p> : null}

        {footerVariant === 'footer-actions' && onApply ? (
          <div className="new-design-hex-picker-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              {cancelLabel}
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={onApply}>
              {applyLabel}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default FloorPlanEditModal;
